import React from "react";
import { tracer } from "./tracing";
import ErrorFallback from "./pages/Fallback";

export class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    errorDetails: null
  };

  static getDerivedStateFromError(error) {
    return { hasError: true, errorDetails: error };
  }

  componentDidCatch(error, info) {
    const location = window.location;

    const span = tracer.startSpan(
      `Critical React Error at route: ${location.pathname}`
    );

    span.setAttribute("path", location.pathname);
    span.setAttribute("error.object", error.toString());
    span.setAttribute("componentStack", info.componentStack);

    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      span.setAttribute("sessionId", sessionId);
    }
    span.recordException(error);
    span.setStatus({ code: 2, message: error.toString() });
    span.end();
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }
    return this.props.children;
  }
}
